/*eslint-disable*/
export default Object.freeze(GLOBAL_CONFIG);
